import React from "react";
import { useRecoilState } from "recoil";
import { EvidenceSearchFilter, evidenceFiltersAtom } from "@state/FilterState";
import { Icon_Filter_Remove } from "@assets/images";

type Props = {
  evidenceCount: number;
  activityTypesCount: number;
  addedToAuditCount: number;
};

const EvidenceListHeader: React.FC<Props> = (props) => {
  const [filters, setFilters] = useRecoilState<EvidenceSearchFilter[]>(evidenceFiltersAtom);

  const removeFilter = (filter: EvidenceSearchFilter) => {
    setFilters((prevFilters) => {
      const index = prevFilters.findIndex(
        (_filter) => _filter.type === filter.type && _filter.option === filter.option
      );

      if (index !== -1) {
        return prevFilters.filter((_, i) => i !== index);
      } else {
        return prevFilters;
      }
    });
  };

  return (
    <div className="flex justify-center mt-5">
      <div className="flex justify-center items-center max-w-app-column w-full pl-safe-area-l pr-safe-area-r">
        <div className="flex flex-col w-full pt-3 bg-white rounded-lg shadow-[0px_4px_12px_0px_rgba(0,0,0,0.08)] overflow-hidden">
          <div className="flex flex-1 gap-y-2 px-4 relative">
            <div className="flex flex-row gap-x-2 pb-3 overflow-x-auto whitespace-nowrap scrollbar-hide relative">
              {/* Evidence */}
              <div className="flex flex-row mr-2 flex-shrink-0">
                <div className="mr-1 text-zinc-600 text-xs font-bold leading-tight">{props.evidenceCount}</div>
                <div className="text-zinc-600 text-xs font-acc-medium leading-tight">{"Evidences"}</div>
              </div>
              <div className="flex w-[1px] bg-zinc-200 flex-shrink-0"></div>
              {/* Added to audit */}
              <div className="flex flex-row mx-2 flex-shrink-0">
                <div className="mr-1 text-zinc-600 text-xs font-bold leading-tight">{props.addedToAuditCount}</div>
                <div className="text-zinc-600 text-xs font-acc-medium leading-tight">{"Added to audit"}</div>
              </div>
              <div className="flex w-[1px] bg-zinc-200 flex-shrink-0"></div>
              {/* Activity types */}
              <div className="flex flex-row ml-2 flex-shrink-0">
                <div className="mr-1 text-zinc-600 text-xs font-bold leading-tight">{props.activityTypesCount}</div>
                <div className="text-zinc-600 text-xs font-acc-medium leading-tight">{"Activity types"}</div>
              </div>
              <div className="flex w-4 h-4 flex-shrink-0" />
              {/* Gradient overlay */}
            </div>
            <div className="absolute right-4 top-0 bottom-0 w-8 h-4 pointer-events-none bg-gradient-to-l from-white to-transparent"></div>
          </div>
          {filters.length > 0 && (
            <div className="flex flex-row mx-4 items-center gap-2 pt-1 pb-3 ">
              <div className="flex flex-col items-center">
                <div className="text-zinc-600 text-xs font-bold leading-tight">{"Filter"}</div>
              </div>
              <div className="flex flex-row flex-wrap gap-2">
                {filters.map((filter) => (
                  <button
                    className="flex flex-row bg-gray-200 rounded py-1.5 px-2 gap-2 overflow-hidden justify-center items-center"
                    key={filter.option}
                    onClick={() => removeFilter(filter)}
                  >
                    <div className="text-xs font-semibold text-blue-600">{filter.label}</div>
                    <img
                      className=""
                      src={Icon_Filter_Remove}
                    />
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EvidenceListHeader;
